import Vue from 'vue'
import Router from 'vue-router'

import authMiddleware from './middleware/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/connexion',
      name: 'login',
      meta: {
        auth: false,
        layout: 'Login'
      },
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
    },
    {
      path: '/services',
      name: 'services',
      component: () => import(/* webpackChunkName: "servicesIndex" */ './views/services/Index.vue')
    },
    {
      path: '/services/nouveau',
      name: 'services/new',
      component: () => import(/* webpackChunkName: "servicesNew" */ './views/services/New.vue')
    },
    {
      path: '/services/:id/modifier',
      name: 'services/edit',
      component: () => import(/* webpackChunkName: "servicesEdit" */ './views/services/Edit.vue')
    },
    {
      path: '/domaines',
      name: 'domains',
      component: () => import(/* webpackChunkName: "domains" */ './views/domains/Index.vue')
    },
    {
      path: '/domaines/nouveau',
      name: 'domains/new',
      component: () => import(/* webpackChunkName: "domains" */ './views/domains/New.vue')
    },
    {
      path: '/domaines/:id/modifier',
      name: 'domains/edit',
      component: () => import(/* webpackChunkName: "domains" */ './views/domains/Edit.vue')
    },
    {
      path: '/users/delete',
      name: 'users/delete',
      component: () => import(/* webpackChunkName: "users" */ './views/users/Delete.vue')
    }
  ]
})

router.beforeEach(authMiddleware)

export default router
